<template>
  <div class="home">

    請以正確的方式進行進入系統

    <hr>

<!--    testPostValue:{{testPostValue}}-->
<!--    <button class="btn btn-primary" @click="doPost" >送出 post</button>-->

<!--    testGetValue:{{testGetValue}}-->
<!--    <button class="btn btn-primary" @click="doGet" >送出 get </button>-->

<!--    testTestJ:{{testTestJ}}-->
<!--    <button class="btn btn-primary" @click="doTestJ" >送出 testJ </button>-->

    <hr>
    <div v-html='testResult'></div>
    <hr>
    <button class="btn btn-primary" @click="do_getCouponList" >送出 getCouponList </button>
    =
    <button class="btn btn-primary" @click="do_test_route" >test Route</button>
    =
    <button class="btn btn-primary" @click="do_test_allApi" >test All Api</button>
    =
    <button class="btn btn-primary" @click="do_test_getCouponList" >送出 getCouponList TestAll </button>
    <button class="btn btn-primary" @click="do_test_getMyCoupons" >送出 getMyCoupons TestAll </button>
    <button class="btn btn-primary" @click="do_test_getCouponDetail" >送出 getCouponDetail TestAll </button>
    <button class="btn btn-primary" @click="do_test_getCoupon" >送出 getCoupon TestAll </button>
    <button class="btn btn-primary" @click="do_test_useCoupon" >送出 useCoupon TestAll </button>

  </div>
</template>

<script>
import apiCoupon from "@/js/apiCoupon";

export default {
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      testPostValue:"",
      testGetValue:"",
      testTestJ:"",
      testResult:"",
      TEST_DATA_subID_Empty:"",
      TEST_DATA_subID_Exist:"",
      TEST_DATA_couponSID_NoExist:"",
      TEST_DATA_couponSID_Exist:"",

    }
  },
  components: {
  },
  methods: {
    async doPost() {
      let that=this;
      apiCoupon.api_testPost("valuePost").then((data)=>{
        that.testPostValue=data.data;
      })
    },
    async doGet() {
      let that=this;
      apiCoupon.api_testGet("valueGet").then((data)=>{
        that.testGetValue=data.data;
      })
    },
    async doTestJ() {
      let that=this;
      apiCoupon.api_test("valueGet").then((data)=>{
        that.testTestJ=data.data;
      })
    },
    async do_test_route() {
      this.$router.push({ name: 'about', query: { ID: 0 }})
    },
    async do_getCouponList() {
      let that=this;
      apiCoupon.api_getCouponList("",396).then((data)=>{
        that.testResult=JSON.stringify(data.data);
      })
    },
    async do_test_allApi(){
      await this.do_test_getCouponList();
      await this.do_test_getMyCoupons();
      await this.do_test_getCouponDetail();
      await this.do_test_getCoupon();
      await this.do_test_useCoupon();
    },
    startTest(){
      this.testResult="";
    },
    async do_test_getCouponList(){
      this.startTest();
      let that=this;

      let testData=[
        {
          subID:"",
          couponTag:"",
          Memo:"case 1",
          Expect:(data)=>{
            return that.expect_statusCode_001(data);
          }
        },
        {
          subID:"1",
          couponTag:"1",
          Memo:"case 2",
          Expect:(data)=>{
            return that.expect_statusCode_001(data);
          }
        },
        {
          subID:"60000356",
          couponTag:"1",
          Memo:"case 3 60000356",
          Expect:(data)=>{
            return that.expect_statusCode_001(data);
          }
        },
      ];

      testData.forEach((item,index)=>{
        apiCoupon.api_getCouponList(item.subID,item.couponTag).then((data)=>{
          that.checkResult(that,index,item,data);
        })
      })

    },
    async do_test_getCoupon(){
      this.startTest();
      let that=this;

      let testData=[
        {
          subID:"0",
          couponSID:"277",
          Memo:"case 1",
          Expect:(data)=>{
            return that.expect_statusCode_001(data);
          }
        },
        {
          subID:"0",
          couponSID:"277",
          Memo:"case 2",
          Expect:(data)=>{
            return that.expect_statusCode_001(data);
          }
        },
        {
          subID:"60000356",
          couponSID:"2565",
          Memo:"case 3 60000356",
          Expect:(data)=>{
            return that.expect_statusCode_001(data);
          }
        },
      ];

      testData.forEach((item,index)=>{
        apiCoupon.api_getCoupon(item.subID,item.couponSID).then((data)=>{
          that.checkResult(that,index,item,data);
        })
      })

    },
    async do_test_useCoupon(){
      this.startTest();
      let that=this;

      let testData=[
        {
          subID:"60000356",
          couponSID:"2565",
          userCouponSID:"2224598",
          Memo:"case 1",
          Expect:(data)=>{
            return that.expect_statusCode_001(data);
          }
        },
      ];

      testData.forEach((item,index)=>{
        apiCoupon.api_useCoupon(item.subID,item.couponSID,item.userCouponSID).then((data)=>{
          that.checkResult(that,index,item,data);
        })
      })

    },
    async do_test_getMyCoupons(){
      this.startTest();
      let that=this;

      let testData=[
        {
          subID:"60000356",
          isUsed:"Y",
          Memo:"case 1 60000356 Y",
          Expect:(data)=>{
            return that.expect_statusCode_001(data);
          }
        },
        {
          subID:"60000356",
          isUsed:"N",
          Memo:"case 2 60000356 N",
          Expect:(data)=>{
            return that.expect_statusCode_001(data);
          }
        },
        {
          subID:"0",
          isUsed:"Y",
          Memo:"case 3 0 Y",
          Expect:(data)=>{
            return that.expect_statusCode_001(data);
          }
        },
        {
          subID:"0",
          isUsed:"N",
          Memo:"case 4 0 N",
          Expect:(data)=>{
            return that.expect_statusCode_001(data);
          }
        },
      ];

      testData.forEach((item,index)=>{
        apiCoupon.api_getMyCoupons(item.subID,item.isUsed).then((data)=>{
          that.checkResult(that,index,item,data);
        })
      })

    },
    async do_test_getCouponDetail(){
      this.startTest();
      let that=this;

      let testData=[
        {
          subID:"60000356",
          userCouponSID:"2224598",
          couponSID:"2565",
          received:"1",
          Memo:"case 1 60000356 Y",
          Expect:(data)=>{
            return that.expect_statusCode_000(data);
          }
        },
        {
          subID:"60000356",
          userCouponSID:"2224598",
          couponSID:"2565",
          received:"0",
          Memo:"case 1 60000356 Y",
          Expect:(data)=>{
            return that.expect_statusCode_000(data);
          }
        },
      ];

      testData.forEach((item,index)=>{
        apiCoupon.api_getCouponDetail(item.subID,item.userCouponSID,item.couponSID,item.received).then((data)=>{
          that.checkResult(that,index,item,data);
        })
      })

    },
    checkResult(that,index,testCase,data){
      if (testCase.Expect(data)) {
        that.formatResult(that,index,testCase,true);
      }else{
        that.formatResult(that,index,testCase,false);
      }
    },
    expect_statusCode_001(data){
      if (data.data.statusCode==="001") {
        return true;
      }else{
        return false;
      }
    },
    expect_statusCode_000(data){
      if (data.data.statusCode==="000") {
        return true;
      }else{
        return false;
      }
    },
    formatResult(that,index,testCase,passOrFail){
      if (passOrFail){
        that.testResult+=testCase.Memo +" test"+index+" pass </br>";
      }else{
        that.testResult+=testCase.Memo +" test"+index+" fail </br>";
      }

    }
  },
}
</script>
